/**
 * 정규표현식 상수
 */
export const RegExpConst = {
  //----------------------------------
  // RegExr Pattern
  //----------------------------------
  // 주민등록번호 패턴
  PATTERN_RESIDENT_REG_NUM: /^(?:[0-9]{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[1,2][0-9]|3[0,1]))-[1-4][0-9]{6}$/,
  // 사업자등록번호 패턴
  PATTERN_BUSINESS_REG_NUM: /^(\d{3,3})+[-]+(\d{2,2})+[-]+(\d{5,5})/,
  // 휴대폰번호 패턴
  PATTERN_MOBILE_NUM: /^\d{3}-\d{3,4}-\d{4}$/,
  // 전화번호 패턴
  PATTERN_PHONE_NUM: /^\d{2,4}-\d{3,4}-?\d{4}$/,
  // 농업인경영체번호 패턴
  PATTERN_FARMER_REG_NUM: /^[0-9]{10}$/,
  // 비밀번호 패턴
  PATTERN_PASSWORD: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d`~!@#$%^&*()-_+={}|']{8,}$/,
  // 아이디 패턴
  PATTERN_USERNAME: /^[A-Za-z0-9.@]{5,20}$/,
  // image url 패턴
  ABSOLUTE_URL_PATTERN: /https?:\/\//g,
} as const;
